import { msg } from "@lit/localize";

import { addToast } from "../components/toast/toasts-stack";
import { ToastVariant } from "../components/toast/toast";
import { Logger } from "../services/logger";

// This must match GlobalToastKind defined in GlobalToastKind.cs
export enum GlobalToastKind {
	DisabledEstimationSubscription,
}

export function showGlobalToast(url: URL): void {
	const value = url.searchParams.get("msg");
	if (value === null) {
		return;
	}

	const kind = parseInt(value, 10);
	const message = getToastMessage(kind);
	if (message === null) {
		Logger.warning(`Unknown global toast value: ${value}`);
		return;
	}

	addToast({
		id: `global-toast-${kind}`,
		message: message,
		variant: ToastVariant.Positive,
		closeTimeout: 15_000,
	});
}

function getToastMessage(kind: GlobalToastKind): string | null {
	if (kind === GlobalToastKind.DisabledEstimationSubscription) {
		return msg("Odstranění sledování proběhlo úspěšně.");
	}

	return null;
}
